module.exports = __webpack_public_path__ + "assets/8bc3aa92c556bbc4bde34cb28a4f83d5.png";